import React from "react";
import { FormattedMessage as FM } from "react-intl";

import { PlusCircleIcon } from "components/Icons";

function ToolButton({ action, label, handleAction }) {
  return (
    <button
      className="bg-sky-950 text-white items-center h-18 text-md hover:bg-sky-800 active:scale-90 px-4 rounded-md shadow-lg transform duration-75"
      onClick={(e) => handleAction(e, action)}
    >
      <PlusCircleIcon className="mx-auto current-white w-6 fill-current" />
      <span className="text-amber-300">
        <FM id={`board.${label}`} />
      </span>
    </button>
  );
}

export default ToolButton;
